var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.apiData)?_c('div',{staticClass:"version-container"},[_c('b',[_vm._v("Versions:")]),_c('div',[_vm._v(" Service Desk UI: "+_vm._s(_vm.appVersion)+" ")]),_vm._l((_vm.apiData),function(row,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(row.name)+": "+_vm._s(row.version)+" ")])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }